import React from 'react';
import './heroSection.css';

const HeroSection = () => (
    <section className="hero-section">
        <div className="hero-shape">
            <div className='img-hero' style={{
                backgroundImage: 'url(/assets/imgs/about/heroSection/fondo.jpg)'
            }}></div>
        </div>
        <div className="hero-text line-height-clss">
            <p className="hero-subtitle">FIVE REASONS WHY</p>
            <h1 className="hero-title line-height-clss">We are your<br/> Best Choice</h1>
        </div>
    </section>
);

export default HeroSection;
